import { validate } from 'src/shared/helpers';

export const complianceAssessmentValidator = (
  name: string,
  values: Record<string, number>,
): string => {
  switch (name) {
    case 'plannedDumpQuantity':
    case 'plannedExcavationQuantity': {
      if (isNaN(values[name])) {
        return 'Please enter a valid number.';
      }
      break;
    }

    default: {
      return validate(name, values);
    }
  }
  return '';
};
